import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Dialog, Button, Link } from '@mui/material';
import { useAppState } from '../states/app-state';
import styles from './Notifier.module.scss';
import DisabledClickLoading from '../components/DisabledClickLoading'; // added by Bearer Web Developer
import { useThemeMode } from '../states/contexts/theme'; // added by Bearer Web Developer

const Notifier: React.FunctionComponent<IProps> = observer((props) => {
  const appStore = useAppState();

  const { snackMessage } = appStore;

  // added by Bearer Web Developer start
  const [loading, setLoading] = useState(false);
  const handleClickaSync = async () => {
    if (snackMessage?.handleClick && snackMessage?.hasLoadingForHandleClick) {
      setLoading(true);
      await snackMessage?.handleClick()
      setLoading(false);
      appStore.setSnackMessage(undefined);
    }
  }
  const handleOpenningaSync = async () => {
    setLoading(true);
    if (snackMessage?.handleOpenning) {
      await snackMessage?.handleOpenning();
    }
    setLoading(false);
  }
  // added by Bearer Web Developer end
  
  const hide = () => {
    // appStore.setSnackMessage(undefined); // commented by Bearer Web Developer
    // added by Bearer Web Developer start
    if (snackMessage?.handleClick) {
      if (snackMessage?.hasLoadingForHandleClick) {
        handleClickaSync();
      } else {
        snackMessage?.handleClick();
        appStore.setSnackMessage(undefined);
      }
    } else {
      appStore.setSnackMessage(undefined);
    }
    // added by Bearer Web Developer end
  };
  // added by Bearer Web Developer start
  React.useEffect(() => {
    if (snackMessage?.handleOpenning && snackMessage?.hasLoadingForOpenning) {
      handleOpenningaSync();
    } else if (snackMessage?.handleOpenning) {
      snackMessage?.handleOpenning();
    }
  }, []);
  // added by Bearer Web Developer end
  // commented by Bearer Web Developer start
  // if (!snackMessage) {
  //   return null;
  // }
  // commented by Bearer Web Developer end
  const { theme } = useThemeMode(); // added by Bearer Web Developer
  return (
    // modified by Bearer Web Developer start
    <Dialog open={!!snackMessage} // true changed to !!snackMessage by Bearer Web Developer
      slotProps={{
        paper: {
          sx: {
            borderRadius: "10px",
            backgroundColor: theme === "dark" ? 'var(--neutral-hsb-30, #4D4D4D)' : '#fff'
          },
          classes: { root: styles.root }
        },
      }}
    >
      <div className={styles.main} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
        {snackMessage?.title && <h4>{snackMessage?.title}</h4>} {/* added by Bearer Web Developer */}
        <div className={snackMessage?.image ? styles.content : ''} >
          <p>{snackMessage?.message}</p>
          {/* added by Bearer Web Developer start */}
          {
            snackMessage?.image &&
            <img src={snackMessage?.image?.src} alt=""
              width={snackMessage?.image?.width}
              height={snackMessage?.image?.height}
            />
          }
          {/* added by Bearer Web Developer end */}
        </div>
        <div className={styles.buttons}>
          <Button onClick={hide} className={styles.button}>
            <span>{snackMessage?.buttonMessage || "OK"}</span>
          </Button>
          {loading && <DisabledClickLoading />} {/* added by Bearer Web Developer (for loading) */}
          {/* added by Bearer Web Developer start */}
          {snackMessage?.hasSopportLink &&
            <Link className={styles.support} target="_blank" href={appStore.webAppRemoteConfigParameters?.supportUrl}><span>Support</span></Link>
          }
          {/* added by Bearer Web Developer end */}
        </div>
      </div>
    </Dialog>
    // modified by Bearer Web Developer end
    // <Snackbar
    //   anchorOrigin={{
    //     vertical: 'bottom',
    //     horizontal: 'left',
    //   }}
    //   open={true}
    //   autoHideDuration={6000}
    //   onClose={hide}
    //   ContentProps={{
    //     'aria-describedby': 'message-id',
    //   }}
    //   message={snackMessage.message}
    //   action={[
    //     <IconButton
    //       key="close"
    //       aria-label="Close"
    //       color="inherit"
    //       className={classes.close}
    //       onClick={hide}
    //     >
    //       <CloseIcon />
    //     </IconButton>,
    //   ]}
    // />
  );
});

interface IProps {
}

export default (Notifier);
